import { defineNuxtPlugin } from '#imports'
import { registerGlobalComponents } from '@components/_globals'
import messageService from '@services/message-service'
import { messagesKey } from '@composables/use-messages'
import clickOutside from '@directives/clickOutside'
import safeHtml from '@directives/safeHtml'

export default defineNuxtPlugin({
    name: 'app-registrations',
    setup(nuxtApp) {
        const app = nuxtApp.vueApp

        registerGlobalComponents(app)
        app.directive('click-outside', clickOutside)
        app.directive('safe-html', safeHtml)
        app.provide(messagesKey, messageService)
    },
})
